export default __webpack_public_path__ + "static/client-7-8fa7b7d9a63238ef0823f96aa6c5b72a.webp";